import { Route } from '@angular/router';
import { AuthGuard, PermissionsGuard } from '@rslweb/auth-data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('@rslweb/auth/routes').then((m) => m.authRoutes),
  },
  {
    path: 'mobile',
    loadChildren: () => import('@rslweb/mobile/routes').then((m) => m.MobileRoutes),
  },
  {
    path: 'customer',
    loadChildren: () =>
      import('@rslweb/public/routes').then((m) => m.publicRoutes),
  },
  {
    path: '',
    loadComponent: () =>
      import('@rslweb/shared/layout').then((m) => m.SharedLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'casting',
        loadChildren: () =>
          import('@rslweb/manufacturing/route').then((m) => m.castingRoutes),
        // canActivate: [PermissionsGuard],
        // data: { requiredPermission: 'View_CastingPlan' },
      },
      {
        path: 'firing',
        loadChildren: () =>
          import('@rslweb/manufacturing/route').then((m) => m.firingRoutes),
        // canActivate: [PermissionsGuard],
        // data: { requiredPermission: ['View_Firing', 'View_FiringPlan'] },
      },
      {
        path: 'glazing',
        loadChildren: () =>
          import('@rslweb/manufacturing/route').then((m) => m.glazingRoutes),
        //canActivate: [PermissionsGuard],
        //data: { requiredPermission: 'View_CastingPlan' },
      },
      {
        path: 'quality-control',
        loadChildren: () =>
          import('@rslweb/quality-control/route').then((m) => m.routes),
        // canActivate: [PermissionsGuard],
        // data: {
        //   requiredPermission: [
        //     'View_ReviewRequests',
        //     'View_QcInspections',
        //     'View_Repairs',
        //     'View_DamagesList',
        //     'View_Barcodes',
        //   ],
        // },
      },
      {
        path: 'dealers',
        loadChildren: () =>
          import('@rslweb/customer/route').then((m) => m.routes),
        // canActivate: [PermissionsGuard],
        // data: { requiredPermission: 'View_Dealer' },
      },
      {
        path: 'sales-purchase',
        loadChildren: () =>
          import('@rslweb/sales-routes/route').then((m) => m.routes),
        canActivate: [PermissionsGuard],
        // data: {
        //   requiredPermission: [
        //     'View_SalesOrder',
        //     'View_ProductSet',
        //     'View_Route',
        //     'View_ReturnItems',
        //   ],
        // },
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('@rslweb/inventory/route').then((m) => m.routes),
      },
      {
        path: 'supplier',
        loadChildren: () =>
          import('@rslweb/supplier-routes').then((m) => m.routes),
      },
      {
        path: 'lab',
        loadChildren: () => import('@rslweb/lab-routes').then((m) => m.routes),
      },
      {
        path: 'hr',
        loadChildren: () => import('@rslweb/hr-routes').then((m) => m.routes),
      },
      {
        path: 'role-permission',
        loadChildren: () =>
          import('@rslweb/role-permission/routes').then((m) => m.routes),
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('@rslweb/reporting/routes').then((m) => m.routes),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('@rslweb/financial-router').then((m) => m.routes),
        // canActivate: [PermissionsGuard],
        // data: { requiredPermission: ['View_Role', 'View_Permission', 'View_RolePermission'] },
      },

      {
        path: 'moulding',
        loadChildren: () =>
          import('@rslweb/manufacturing/route').then((m) => m.mouldingRoutes),
      },
      {
        path: 'payroll',
        loadChildren: () =>
          import('@rslweb/payroll/routes').then((m) => m.routes),
      },
      {
        path: 'shared',
        loadChildren: () =>
          import('@rslweb/shared/routes').then((m) => m.routes),
        /*canActivate: [PermissionsGuard],
        data: {
          requiredPermission: [
            'View_Notifications',
            
          ],
        },*/
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('@rslweb/admin/routes').then((m) => m.routes),
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];
